import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SiteHeader from './SiteHeader';
import Footer from './Footer';

// Directory of every city with a published "things to do" page (see
// app.py's list_public_event_pages / SocialEventPageRepository.
// get_latest_per_city) - linked from the site footer as "City Guides" so a
// visitor who lands on one city's page (or just the footer) can find
// others. Deliberately just a plain list, not a search/map UI - the number
// of cities is small enough that scanning a list is the fastest path.
function LocalEventsIndex() {
  const [cities, setCities] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    document.title = 'City Guides | OkGather';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Browse OkGather\'s local events guides - handpicked things to do in each city, updated regularly.');
    }
    fetch('/api/public/event-pages')
      .then((response) => {
        if (!response.ok) throw new Error('Failed to load cities');
        return response.json();
      })
      .then((data) => !cancelled && setCities(data.cities || []))
      .catch((err) => !cancelled && setError(err.message))
      .finally(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="page-wrapper" style={{ minHeight: '100vh', backgroundColor: '#FAFAFA' }}>
      <SiteHeader />
      <main className="main-wrapper">
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '30px 20px' }}>
          <p style={{ fontSize: '0.9rem', color: '#6B7280', marginBottom: '24px' }}>
            <Link to="/" style={{ color: '#6B46C1', textDecoration: 'none' }}>Home</Link>
            {' / '}
            <span>City Guides</span>
          </p>

          <header style={{ marginBottom: '20px' }}>
            <h1 style={{ margin: '0 0 10px 0', color: '#1F2937', fontSize: '2.25rem', fontWeight: '800', lineHeight: '1.2' }}>
              City Guides
            </h1>
          </header>

          <p style={{ color: '#374151', fontSize: '1rem', lineHeight: '1.6', marginBottom: '28px' }}>
            Handpicked local events, updated regularly - pick a city to see what's on.
          </p>

          {error ? (
            <p style={{ color: '#666' }}>Couldn't load the city list right now - try again shortly.</p>
          ) : cities === null ? (
            <p style={{ color: '#666' }}>Loading...</p>
          ) : cities.length === 0 ? (
            <p style={{ color: '#666' }}>No city guides published yet - check back soon.</p>
          ) : (
            <ul style={{ padding: 0, listStyle: 'none' }}>
              {cities.map((c) => (
                <li key={c.city_slug} style={{ borderTop: '1px solid #eee', padding: '16px 0' }}>
                  <Link
                    to={`/local-events/${c.city_slug}`}
                    style={{ color: '#6B46C1', fontWeight: '700', fontSize: '1.1rem', textDecoration: 'none' }}
                  >
                    {c.city} &rarr;
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default LocalEventsIndex;
